import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

Vue.use(Vuex);
const axios = require("axios");
export default new Vuex.Store({
  state: {
    usuario: "",
    error: "",
    loader: false,
    desdeCategoria: "",
    hastaCategoria: "",
    buscarCategoria: "",
    buscarProductoCategoria: "",
    buscarProductoTermino: "",
  },
  mutations: {
    setUsuario(state, payload) {
      state.usuario = payload;
      if (payload === null) {
        state.usuario = "";
      }
    },
    setError(state, payload) {
      state.error = payload;
    },
    setLoader(state, payload) {
      state.loader = payload;
    },
    setCateogriasBuscador(state, payload) {
      state.desdeCategoria = payload.desde;
      state.hastaCategoria = payload.hasta;
      state.buscarCategoria = payload.search;
    },
    setProductoBuscador(state, payload) {
      state.buscarProductoCategoria = payload.categoria;
      state.buscarProductoTermino = payload.search;
    },
  },
  actions: {
    ingresoUsuario({ commit }, payload) {
      commit("setLoader", true);

      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/auth/auth__controller.php?ot=login&usuario=" +
            payload.usuario +
            "&password=" +
            payload.password
        )
        .then((response) => {
          commit("setLoader", false);

          //Si el usuario existe
          if (response.data.estatus == "ok") {
            commit("setUsuario", {
              usuario: response.data.user,
              id: response.data.id,
              nombre: response.data.nombre,
            });
            localStorage.setItem("id", response.data.id);
            router.push({ name: "admin" });
          }
          //Si el usuario no existe
          else if (response.data.estatus == "error") {
            commit("setError", response.data.errorInfo);
          }
        })
        .catch(function(error) {
          commit("setLoader", false);
        });
    },

    verificarUsuarioConectado({ commit }, payload) {
      if (payload != null) {
        commit("setUsuario", {
          usuario: payload.user,
          id: payload.id,
          nombre: payload.nombre,
        });
      } else {
        commit("setUsuario", null);
      }
    },

    cerrarSesion({ commit }) {
      localStorage.removeItem("id");
      commit("setUsuario", null);
      router.push({ name: "login" });
    },
  },
  getters: {
    existeUsuario(state) {
      if (
        state.usuario === null ||
        state.usuario === "" ||
        state.usuario === undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
});
